import { useQuery } from '@tanstack/react-query';

import { fetchWorkflowsAvailable } from '@/shared/api/lotus';

export const workflowsAvailableKeys = {
  all: ['workflows-available'] as const,
  byUser: (userId: string) => ['user', userId, 'workflows-available'] as const,
};

export function useWorkflowsAvailableQuery(userId: string | undefined) {
  return useQuery({
    queryKey: workflowsAvailableKeys.byUser(userId ?? ''),
    queryFn: ({ signal }) => fetchWorkflowsAvailable(userId!, signal),
    enabled: !!userId,
    meta: {
      toast: {
        title: 'Could not check workflow availability',
        description: 'Failed to determine available clinical workflows.',
      },
    },
  });
}
